import { z } from 'zod';
/**
 * Cartela dos primeiros passos: sete carimbos que mostram o que a pessoa já fez
 * com o Secretário. Tudo é calculado do que já existe na conta (lembretes,
 * contatos, lembranças, conversa por voz); não há pontos, sequência nem prazo
 * que zera. O servidor manda o texto de cada passo; o app sabe o que cada
 * identificador abre.
 */
export const JOURNEY_STEP_IDS = [
    /** A conta existe: carimbado desde o começo. */
    'chegada',
    /** Personagem e personalidade escolhidos na entrada: carimbado desde o começo. */
    'jeito',
    /** O primeiro pedido resolvido (lembrete, compromisso ou conversa). */
    'pedido',
    /** Uma conversa por voz. */
    'voz',
    /** Uma lembrança no Caderno. */
    'caderno',
    /** Um contato trazido para o app. */
    'pessoas',
    /** Uma conta do mês anotada. */
    'conta',
    /** Um documento pronto: entra no lugar da voz para quem não tem conversa por voz. */
    'documento',
];
/** Quantos carimbos a cartela tem. */
export const JOURNEY_TOTAL = 7;
/** Por quantos dias, depois da entrada, a cartela aparece no painel Hoje. */
export const JOURNEY_WINDOW_DAYS = 7;
export const journeyStepSchema = z.object({
    /** Um de `JOURNEY_STEP_IDS`; o app ignora a ação de um passo que não conhece. */
    id: z.string().min(1).max(24),
    title: z.string().min(1).max(60),
    line: z.string().max(140),
    done: z.boolean(),
});
export const journeySchema = z.object({
    steps: z.array(journeyStepSchema).max(12),
    doneCount: z.number().int().min(0),
    total: z.number().int().min(0),
    complete: z.boolean(),
    /** A pessoa ainda está na primeira semana: a cartela aparece no painel Hoje. */
    firstWeek: z.boolean(),
});
